module.exports = __webpack_public_path__ + "static/img/gaozhongyingyu2.9a7a7103.jpg";